import store from '@state/store'

export default [
  {
    path: '/',
    name: 'homepage',
    component: () => lazyLoadView(import('@views/homepage.vue')),
  },
  {
    path: '/data-center',
    name: 'data-center',
    alias: '/pusat-data',
    component: () => lazyLoadView(import('@views/pages/data-center.vue')),
  },
  {
    path: '/data-center/:klaster_slug/:slug',
    name: 'data-center-single',
    alias: '/pusat-data/:klaster_slug/:slug',
    component: () =>
      lazyLoadView(import('@views/singles/data-center-single.vue')),
  },
  {
    path: '/glossary',
    name: 'glossary',
    alias: '/glosarium',
    component: () => lazyLoadView(import('@views/pages/glossary.vue')),
  },
  {
    path: '/news',
    name: 'news',
    alias: '/artikel',
    component: () => lazyLoadView(import('@views/pages/news.vue')),
  },
  {
    path: '/news/:slug',
    name: 'news-single',
    alias: '/artikel/:slug',
    component: () => lazyLoadView(import('@views/singles/news-single.vue')),
  },
  {
    path: '/academic-journal',
    name: 'academic-journal',
    alias: '/jurnal-akademik',
    component: () => lazyLoadView(import('@views/pages/academic-journal.vue')),
  },
  {
    path: '/academic-article/:slug',
    name: 'academic-journal-single',
    alias: ['/jurnal-akademik/:slug', '/academic-journal/:slug'],
    component: () =>
      lazyLoadView(import('@views/singles/academic-journal-single.vue')),
  },
  {
    path: '/infographic/:popup?',
    name: 'infographic',
    alias: '/infografik/:popup?',
    component: () => lazyLoadView(import('@views/pages/infographic.vue')),
  },
  {
    path: '/directories/:popup?',
    name: 'directory',
    alias: '/direktori/:popup?',
    component: () => lazyLoadView(import('@views/pages/directory.vue')),
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => lazyLoadView(import('@views/pages/faq.vue')),
  },
  {
    path: '/legal-analysis',
    name: 'legal-analysis',
    alias: '/analisis-legal',
    component: () => lazyLoadView(import('@views/pages/legal-analysis.vue')),
  },
  {
    path: '/legal-analysis/:slug/:category?/:catID?',
    name: 'legal-analysis-single',
    alias: '/analisis-legal/:slug/:category?/:catID?',
    component: () =>
      lazyLoadView(import('@views/singles/legal-analysis-single.vue')),
  },
  {
    path: '/contact',
    name: 'contact',
    alias: '/kontak',
    component: () => lazyLoadView(import('@views/contact.vue')),
  },
  {
    path: '/search',
    name: 'search',
    alias: '/cari',
    component: () => lazyLoadView(import('@views/search.vue')),
  },
  {
    path: '/about',
    name: 'about',
    alias: '/tentang-kami',
    component: () => lazyLoadView(import('@views/about-us.vue')),
  },
  {
    path: '/tou',
    name: 'tou',
    component: () => lazyLoadView(import('@views/term-of-use.vue')),
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404.vue').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading.vue').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout.vue').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
